import containerActions from "./containersActions";
import itemsActions from "./itemsActions";
import configurationsActions from "./configurationsActions";
import artworkActions from "./artworkActions";
import reportsActions from "./reportsActions";
import operationsActions from "./operationsActions";
import hubspotActions from "./hubspotActions";

const allActions = {
  configurationsActions,
  containerActions,
  artworkActions,
  itemsActions,
  reportsActions,
  operationsActions,
  hubspotActions,
};

export default allActions;
